import { render } from "./ChatLoader.vue?vue&type=template&id=116bfbac&scoped=true"
import script from "./ChatLoader.vue?vue&type=script&lang=js"
export * from "./ChatLoader.vue?vue&type=script&lang=js"

import "./ChatLoader.vue?vue&type=style&index=0&id=116bfbac&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116bfbac"]])

export default __exports__